export default __webpack_public_path__ + "static/poster-816bd3a8d5c5fed200f8dbbff71f4394.png";